export default __webpack_public_path__ + "static/media/create-offer.eed54a65.svg";